"use strict";
exports.__esModule = true;
require('../table-scale/table-scale.component.css');
var angular = require("angular");
var TableScaleComponent = /** @class */ (function () {
    function TableScaleComponent($rootScope, $scope, $timeout) {
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.options = { show: true, id: -1 };
        ctrl.$timeout = $timeout;
        ctrl.oldVal = -1;
        ctrl.initComponent();
        $scope.changeVal = function (daty, index) {
            daty.Val = index;
            $scope.checkSave();
            console.log(daty);
        };
        $timeout();
    }
    TableScaleComponent.prototype.initComponent = function () {
        var ctrl = this;
        ctrl.$scope.oldVal = ctrl.$scope.daty.Val;
    };
    TableScaleComponent.prototype.arrayEquals = function (a, b) {
        return (Array.isArray(a) &&
            Array.isArray(b) &&
            a.length === b.length &&
            a.every(function (val, index) { return val === b[index]; }));
    };
    return TableScaleComponent;
}());
exports.TableScaleComponent = TableScaleComponent;
angular.module('smartorg.r6.acts.tableScale', []).directive('tableScale', function () {
    return {
        restrict: 'E',
        scope: {
            smartorg: '=',
            menu: '=',
            daty: '=?',
            checkSave: '=?',
            showCommentBox: '=?',
            showHistoryModal: '=?',
            refreshTable: '=?',
            parentIndex: '=?',
            oldVal: '=?'
        },
        template: require('./table-scale.component.html'),
        controller: TableScaleComponent,
        link: function (scope, element, attrs) {
            scope.$watch('refreshTable', function (newValue, oldValue) {
                // Perform actions with the updated value of yourVariable
                if (oldValue == false && newValue == true) {
                    scope.oldVal = scope.daty.Val;
                }
            });
            scope.$watch('daty', function (newValue, oldValue) {
                // Perform actions with the updated value of yourVariable
                // if (oldValue == false && newValue == true) {
                scope.oldVal = scope.daty.Val;
                // }
            });
        }
    };
});
module.exports = 'smartorg.r6.acts.tableScale';
//# sourceMappingURL=table-scale.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/table-scale/table-scale.component.js